<template>
  <card class="card" title="Editar cuenta">
    <div>
      <form @submit.prevent="actualizarCuenta">


          <div class="row">

            <div class="col-md-6 col-sm-6 col-lg-6">
              <fg-input
              type="texto"
              label="Nombre"
              placeholder="Nombre"
              v-model="usuario.nombre"
            >
            </fg-input>

              
            </div>
            <div class="col-md-6 col-sm-6 col-lg-6">
              <fg-input
              type="email"
              label="Correo"
              placeholder="Escribe tu correo"
              v-model="usuario.correo"
            >
            </fg-input>


            </div>
          </div>


          <fg-input
              type="password"
              label="Contraseña"
              placeholder="Escribe la contraseña"
              v-model="usuario.contrasena"
            >
            </fg-input>




        <div class="text-center">
           
            <input type="submit" class="btn btn-info" value="Actualizar cuenta"/>
            

        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>

import api from '@/util/api.js';
export default {
  data() {
    return {
      usuario: {
        correo:'',
        nombre:'',
        contrasena:''

      },
    };
  },
  methods: {
    actualizarCuenta() {


      let data=new FormData;
      data.append('correo',this.usuario.correo);
      data.append('nombre',this.usuario.nombre);
      data.append('contrasena',this.usuario.contrasena);

      api.post('/user/account',data).then(response=>{

        if(response.data.done){
          alert(response.data.message);
        }else{


          let msg='';

          for(let i in response.data.message){
            msg+=response.data.message[i][0]+'\n';
          }

          alert('Hubo errores actualizando los datos: \n'+msg);
        }


      });
      

    },
  },

  mounted(){


      api.get('/user/accountinfo').then(response=>{


        this.usuario.nombre=response.data.item.nombre;
        this.usuario.correo=response.data.item.correo;
      

      });




  }

};
</script>
<style></style>
